import { Box, Flex } from '@chakra-ui/react';
import { SampleStatus } from '@resistapp/common/types';
import type { OptionProps } from 'chakra-react-select';
import { values } from 'lodash';
import type { CSSProperties } from 'react';
import { IntegratedTextSelect } from '../../selects/integrated-text-select';
import { SampleStatusBadge, formatSampleStatusBadgeLabel } from '../../shared/sample-status-badge';

export type SampleStatusOrEmpty = SampleStatus | ' ';

interface LegendStatusProps {
  status: SampleStatusOrEmpty | undefined;
  onStatusChange: (status: SampleStatusOrEmpty) => void;
  isDisabled: boolean;
}

export function LegendStatus({ status, onStatusChange, isDisabled }: LegendStatusProps) {
  const options = values(SampleStatus)
    .filter(s => s !== SampleStatus.SUBMITTED)
    .map(s => ({
      value: s,
      label: formatSampleStatusBadgeLabel(s),
      disabled: s === SampleStatus.POOLED,
    }));

  return (
    <Flex
      className="export_hide-legend-status"
      marginLeft="-26px"
      paddingRight="5px"
      alignItems="center"
      onClick={e => {
        e.stopPropagation();
      }}
    >
      <IntegratedTextSelect
        options={options}
        value={options.find(o => o.value === status)}
        onChange={option => {
          if (option) {
            onStatusChange(option.value);
          }
        }}
        styles={{
          menuList: base => ({
            ...base,
            width: 'min-content',
            minWidth: '140px',
          }),
        }}
        isDisabled={status === SampleStatus.POOLED || isDisabled}
        Option={Option}
        showArrow={false}
        border="none"
        captureMenuScroll={false}
      >
        <SampleStatusBadge
          status={status}
          labelMode="compact"
          title={formatSampleStatusBadgeLabel(status)}
          whiteSpace="nowrap"
        />
      </IntegratedTextSelect>
    </Flex>
  );
}

const Option = (
  props: OptionProps<{ value: SampleStatus; label: string; disabled: boolean }> & { value: SampleStatus },
) => {
  const { className, cx, getStyles, isDisabled, isFocused, isSelected, innerRef, innerProps } = props;
  const style = getStyles('option', props) as CSSProperties;
  const value = props.value;

  return (
    <Box
      ref={innerRef}
      className={cx(
        {
          option: true,
          'option--is-disabled': isDisabled,
          'option--is-focused': isFocused,
          'option--is-selected': isSelected,
        },
        className,
      )}
      style={style}
      {...innerProps}
    >
      <SampleStatusBadge status={value} whiteSpace="nowrap" />
    </Box>
  );
};
